import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SignalSection } from '../components/SignalSection';
import { ProductReveal } from '../components/ProductReveal';
import { WhyFailedSection } from '../components/WhyFailedSection';
import { IncludesSection } from '../components/IncludesSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { ResultsSection } from '../components/ResultsSection';
import { BonosSection } from '../components/BonosSection';
import { PricingCTA } from '../components/PricingCTA';
import { MatrixRain } from '../components/MatrixRain';
import { RecentPurchasePopup } from '../components/RecentPurchasePopup';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-matrix-bg text-matrix-text selection:bg-matrix-primary selection:text-matrix-bg relative" data-id="element-358">
      {/* Full-page Matrix Rain background */}
      <MatrixRain data-id="element-359" />

      {/* Social proof popup */}
      <RecentPurchasePopup data-id="element-360" />

      <div className="relative z-10" data-id="element-361">
        <HeroSection data-id="element-362" />
        <ProblemSection data-id="element-363" />
        <SignalSection data-id="element-364" />
        <ProductReveal data-id="element-365" />
        <WhyFailedSection data-id="element-366" />
        <IncludesSection data-id="element-367" />
        <ForWhoSection data-id="element-368" />
        <ResultsSection data-id="element-369" />
        <BonosSection data-id="element-370" />
        <PricingCTA data-id="element-371" />

        <Footer data-id="element-372" />
      </div>
    </main>;
}